import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";

import PrimaryButton from "../../../Buttons/PrimaryButton";
import {BcaDeleteIcon} from "../../../../images/BcaIcon";
import BaseDialog from "../../BaseDialog";

import styles from "./styles";

const ConfirmDeleteModal = ({classes, open, title, handleClose, deleteTitle, onDeleteClick, children, modalLoading}) => (
  <BaseDialog
    open={open}
    title={<><i className={'far fa-exclamation-triangle'} />{title}</>}
    data-id={'confirm-deletion-popup'}
    customClasses={classes}
    maxWidth={'sm'}
    modalLoading={modalLoading}
    actions={
      <Grid container spacing={1} justify={"flex-end"}>
        <Grid item>
          <PrimaryButton
            variant={'outlined'}
            text={'Abbrechen'}
            onButtonClick={handleClose}
          />
        </Grid>
        <Grid item>
          <PrimaryButton
            color={'secondary'}
            variant={'outlined'}
            icon={<BcaDeleteIcon />}
            text={deleteTitle}
            onButtonClick={onDeleteClick}
          />
        </Grid>
      </Grid>
    }
  >{children}</BaseDialog>
);

export default withStyles(styles)(ConfirmDeleteModal);